export const LOGIN_USER = 'login_user';
export const REGISTER_USER = 'register_user';
export const AUTH_USER = 'auth_user';
export const LOGOUT_USER = 'logout_user';
export const ADD_NOTIFICATION = 'add_notification';
export const CLEAR_NOTIFICATIONS = 'clear_notifications';
